import { useCallback, useEffect, useState } from 'react';
import { dateKey } from '../utils/dateUtils';

const STORAGE_KEY = 'feriencountdown:celebrations';

function readEvents() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
}

export function useCelebration(now, automaticEvent) {
  const [celebration, setCelebration] = useState(null);

  const play = useCallback((event) => {
    setCelebration({ ...event, instance: Date.now() });
  }, []);

  const close = useCallback(() => {
    setCelebration(null);
  }, []);

  useEffect(() => {
    if (!automaticEvent) return;

    const key = `${dateKey(now)}:${automaticEvent.type}`;
    const played = readEvents();

    if (!played.includes(key)) {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify([...played.slice(-30), key])
      );
      play(automaticEvent);
    }
  }, [
    automaticEvent?.type,
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    play
  ]);

  return {
    celebration,
    play,
    close
  };
}